<template>
	<div class="updateNum">
		<van-nav-bar
		  	:title="$t('checkNum.title')"
			left-arrow
			fixed
			@click-left="$router.push('/Center')">
		</van-nav-bar>
		<p class="text" style="margin: 0;padding:5px 0">{{$t('checkNum.text')}}</p>
		<p class="text2">{{$t('checkNum.text2')}}<input type="text" v-model='phone1' class="telphone" readonly /></p>
		<div class="wrap">
			<van-field	
				v-model="smscode"			
				clearable
				:placeholder="$t('checkNum.inputSMS')"
			 	>
		 	</van-field>
			<van-button v-if='isSms==false' class="check" round type="default"  style="font-weight:bold;font-size:16px;line-height:16px"  @click="sendCode(); ">{{$t('checkNum.SMS')}}</van-button>
			<van-button v-else class='disableCheck' round type="default" style="font-weight:bold;font-size:12px;" :disabled='isSms'><span>{{timer}}</span>{{$t('checkNum.retrieve')}}</van-button>
		</div>		
		<van-button class="certainBtn" round type="default"  style="font-weight:bold;font-size:16px;" @click="next()">{{$t('checkNum.next')}}</van-button>
	</div>
  
</template>

<script>
export default {
	data(){
		return{
			smscode:'',
			smskey:'',
			areacode:'',
			phone:'',
			phone1:'',
			isSms:false,
			timer:60
		}
	},
	created(){
		this.phone=sessionStorage.getItem('telphone');
		var str1=this.phone;
		var reg = /^(\d{3})\d*(\d{4})$/;
		this.phone1 = str1.replace(reg,'$1****$2');
	},

	methods:{
		sendCode(){
			this.$axios({
                method: 'post',
                url: this.$build+'/api/send',
                data:{
                	area_code:this.areacode,
                	phone:this.phone,
                },
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){     		
                	this.$toast({
	            		type:'success',
	            		message:res.data.message,
	            	});   
	            	this.isSms=true;        	
	            	this.smskey=res.data.success.key;
	            	this.phone=sessionStorage.getItem('telphone');
	            	console.log(this.phone);
	            	const vm=this;
	            	// setTimeout(function(){
	            	// 	vm.isSms=false;
	            	// 	console.log(1111111);
	            	// },60000);
	            	vm.isSms=true;
	            	var countdown=setInterval(()=>{
	            		this.timer--;
	            		if(this.timer<=0){
	            			vm.isSms=false;
	            			clearInterval(countdown)
	            		}
	            	},1000)
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('checkNum.message'),
        		});
            });
		},
		next(){
			if(this.smscode){
				this.$axios({
					method:'post',
					headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
					url:this.$build+'/api/user/verify',
					data:{
						key:this.smskey,
						code:this.smscode
					},
				}).then(res => {
					console.log(res);
					if(res.data.status==200){
						this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	const vm=this;
		            	setTimeout(function(){
		            		console.log(1111111);
	            			vm.$router.push('/updateNum');
		            	},1500);
					}else{
						for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
					}
				}).catch(err =>{
					this.$toast({
	            		type:'fail',
	            		message:this.$t('checkNum.message'),
            		});
				})
			}else{
				this.$toast(this.$t('checkNum.pleaseInputSMS'))
			}		
		}
	}
}
</script>

<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-button__text{
		line-height: 1rem
	}
	/deep/ .van-cell{
		font-size: 17px;
	}
	.updateNum{
		width: 100%;
		height: 100vh;
		background: #fff;
	}
	.text{
		margin: 10px  5% 5px;
		text-align: center;
		color: #888;
		font-size: 14px;
		line-height:24px;
	}
	.text2{
		margin-top: 10px;
		margin-bottom: 30px;
		text-align: center;
		color: #444;
	}
	.van-field{
		border-radius: 23px;
		border: 2px solid #000;
		color: #FFB20D;
		width: 60%;
		float: left;
	}
	.wrap{
		width: 90%;
		margin:0 auto;
	}
	.check{
		width: 38%;
		background: #2f75f7;
		color: #fff;
		line-height: 34px;
		float: right;
	}
	.disableCheck{
		width: 35%;
		background: #DFDEDE;
		line-height: 34px;
		float: right;
	}
	.certainBtn{
		width: 90%;
		height: 40px;
		line-height: 40px;
		margin-left: 5%;
		margin-top: 30px;
		background:#000;
		color: #fff;
		font-weight: bold;
		border: none;
	}
	.telphone{
		border: none;
		width: 100px;
	}
</style>>



// WEBPACK FOOTER //
// src/components/checkNum.vue